// removed by extract-text-webpack-plugin
module.exports = {"ServicesPage":"ServicesPage__ServicesPage__1VfWy","title":"ServicesPage__title__1MTNV","window":"ServicesPage__window__REXjB","footnote":"ServicesPage__footnote__1Ocw_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ServicesPage/ServicesPage.css
// module id = 88
// module chunks = 0